import * as Yup from "yup";
import translate from "../../utils/translate";

export const SignInSchema = Yup.object().shape({
  username: Yup.string()
    .required(() => translate('common_required'))
    .test('has-russian-letters', () => translate('loginPage_nameValidationNotCyrillic'), pwd => pwd && !pwd.match(/[а-яА-ЯЁё]/)),
  password: Yup.string()
    .required(() => translate('common_required'))
});